import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../../shared/queries';
import { handleError } from '../../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';
import type { IModem } from '../../../../../../shared/types/modem';

export default function useGetModelDetails(params: { id: number }) {
  return useQuery({
    ...queries.modems.modemDetails(params),
    enabled: !!params.id,
    select: (data): IModem => data.data,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
